import styled from 'styled-components';

export const FormButtonsContainer = styled.div`
  margin-top: 50px;
  display: flex;
`;
